<app-template [hasContentFrame]="true" [titel]="'Lizenzen'">
  <section>
    <h3 style="font-weight: bold">Open-Source-Bibliotheken</h3>
    <h4>Im Redaktionssystem werden folgenden Open-Source-Bibliotheken verwendet:</h4>
    <div class="table-wrapper">
      <table>
        <caption class="cdk-visually-hidden">Übersicht der verwendeten Open-Source-Bibliotheken</caption>
        <thead>
        <tr>
          <th>
            Name
          </th>
          <th>
            Autor
          </th>
          <th>
            Typ
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let license of licenses">
          <td>
            {{license.name}}
          </td>
          <td>
            {{license.author}}
          </td>
          <td>
            {{license.licenseType}}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </section>
  <section>
    <h3 style="font-weight: bold">Versionshinweis</h3>
    <p>Version des Redaktionssystems: {{ resyVersion$ | async }}</p>
  </section>
</app-template>
